
<template>
<div>
 <Menu></Menu> 
  <MenuMovil></MenuMovil> 
 <CoreView></CoreView> 
 <FooterPerfil></FooterPerfil>
  <PerfilOpciones></PerfilOpciones>
</div>
</template>
<script>


import CoreView from '@/components/common/View'

import Menu from '@/components/base/Menu.vue'
import MenuMovil from '@/components/base/MenuMovil.vue'

import PerfilOpciones from '@/components/common/PerfilOpciones.vue';


import FooterPerfil from '@/components/common/FooterPerfil';

export default {
  name: 'MenuUsuario',

  components: {
    CoreView,
    Menu,
    MenuMovil,
        FooterPerfil,
        PerfilOpciones
  }
};




</script>
